<!-- 大图+标题+副标题 文字居中 -->
<template>
	<div>

		<div class="cc w-100" style="position:absolute;  z-index: 90;text-align: center;" :style="titlestyle3">
			<div>
				<div v-if="title" class="ftscimcentertitle" style="font-family: YouSheBiaoTiHei;color: white;">
					{{title}}
				</div>
				<div v-if="subtitle" class="ftscimcentersubtitle"
					style="color: white;text-transform :uppercase;letter-spacing: 20px;">
					{{subtitle}}
				</div>
			</div>
		</div>
		<img class="firstimage" :src="imgobj" @load="onimagesize3">

		</img>

	</div>
</template>

<script>
	export default {
		name: 'firstsceen',
		props: ['imgobj', "title", "subtitle", "stylemode"],
		data() {
			return {
				titlestyle3: {
					color: 'black',
					height:"0px"
				},
				styleObjectbutton: {
					background: 'rgba(255, 255, 255, 0.2)',
					opacity: 1,

				},
			}
		},
		methods: {
			onimagesize3: function(e) {

				var height = e.path[0].clientHeight
			 
				this.titlestyle3.height =(height-50)+ "px"
			}

		},

		mounted() {
			if (this.stylemode == 'blue') {
				this.titlestyle.color = "#263E8B"

			} else if (this.stylemode == 'white') {
				this.titlestyle.color = "white"

			}

			if (this.button == "blue") {
				this.styleObjectbutton.background = '#263E8B'
				this.styleObjectbutton.borderColor = '#263E8B'
				this.styleObjectbutton.border = '1 px solid #263E8B'
			}

		}

	}
</script>


<style>
	@media (max-width: 999px) {
		.ftscimcentertitle {
			font-size: 30px;
			letter-spacing: 2px;
		}

		.ftscimcentersubtitle {
			font-size: 10px;
			letter-spacing: 3px;
		}
	}

	@media (min-width: 1000px) {
		.ftscimcentertitle {
			font-size: 100px;
			letter-spacing: 5px;
		}

		.ftscimcentersubtitle {
			font-size: 20px;
			letter-spacing: 7px;
		}
	}


	.fade-enter-active {
		transition: all 1.5s;
	}

	.fade-enter {
		opacity: 0;
		transform: translateY(-130px);
	}

	.fade2-enter-active {
		transition: all 1.5s;
	}

	.fade2-enter {
		opacity: 0;
		transform: translateY(130px);
	}
</style>
